export const umsValidatePhone = () => {
  'ngInject'

  return {
    require: 'ngModel',
    restrict: 'A',
    link(scope, elm, attrs, ctrl) {
      // this will add phone validator
      ctrl.$validators.phone = function (modelValue) {
        if (ctrl.$isEmpty(modelValue)) {
          return true
        }

        return /^\+?[0-9\-\s()]{6,20}$/.test(modelValue)
      }
    },
  }
}



// WEBPACK FOOTER //
// ./app/shared/directives/ums-validate-phone.directive.js